import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Terracotta es el color de acción: es el color de la "Offer line" en los
 * tomos. Texto blanco sobre #A9553A = 5:1.
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-5 text-[17px] sm:text-xl rounded-2xl min-h-[64px]' : 'px-5 py-3 text-sm rounded-xl';
  return <a href={href} target={href.startsWith('http') ? '_top' : undefined} className={`inline-flex w-full items-center justify-center gap-2 bg-terra-deep text-center font-bold tracking-wide text-white shadow-card transition-[background-color,box-shadow] duration-200 ease-out hover:bg-terra-hover hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-ochre/60 ${sizing} ${className}`} data-id="element-89" data-mp="lkfp303ska7s">
      {children}
    </a>;
}